import cn from 'classnames'
import Image from 'next/image'

import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { cloudflareLoader } from '@mc/image-cloudflare'
import { BREAKPOINTS } from '@mc/media'
import { PageSourceType } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'

import { trackContestLinkClicked, trackContestPromoViewed } from '../../events'
import { ValidatedContestPromoProps } from '../../types'
import styles from './ContestPromoTile.module.scss'

interface ContestPromoTileProps {
  contestPromoProps: ValidatedContestPromoProps
  pageSource: PageSourceType
}

export const ContestPromoTile = ({
  contestPromoProps: { heading, content, contestLink, slug, imageUrl },
  pageSource,
}: ContestPromoTileProps): JSX.Element => {
  const { t } = useTranslation('@mc/next')

  return (
    <TrackingContainer
      onFirstVisible={() => trackContestPromoViewed(pageSource)}
    >
      <section className='container mc-my-10' id='contest-promo-tile'>
        <div
          className={`${styles.overflowContainer} row no-gutters mc-bg-neutral-900`}
        >
          <div className='col-12 col-md-8 d-flex flex-column align-items-center justify-content-center mb-4 mb-md-0'>
            <div
              className={`${styles.contentContainer} d-flex flex-column mc-gap-8 mc-my-13 mc-mx-7 mc-my-md-0`}
            >
              <div className='d-flex flex-column mc-gap-6'>
                <h1 className={cn('mc-text-b1', heading.style)}>
                  {heading.copy}
                </h1>
                <p className={cn(content.style)}>{content.copy}</p>
              </div>
              <Button
                kind='tertiary'
                href={contestLink}
                as='a'
                className='align-self-start'
                onClick={() => trackContestLinkClicked(slug)}
              >
                {t('pen-5236_v2.ctaButton')}
              </Button>
            </div>
          </div>
          <div className='col-12 col-md-4 d-flex align-items-center justify-content-center'>
            <div
              className={`${styles.imageWrapper} mc-w-100 position-relative mc-overflow--hidden`}
            >
              <Image
                src={imageUrl}
                loader={cloudflareLoader}
                alt={heading.copy}
                fill
                style={{ objectFit: 'cover' }}
                sizes={`(max-width: ${BREAKPOINTS.MD}px) 100vw, 400px`}
              />
            </div>
          </div>
        </div>
      </section>
    </TrackingContainer>
  )
}
